import { useNuxtApp } from 'nuxt/app'

/* Ends the Auth0 session and drops everything tied to the identified user. */
export const useLogout = () => {
  const { $auth0, $groundcover, $pendo } = useNuxtApp()

  return async () => {
    $groundcover.updateConfig({ user: null })
    ;($pendo as { clearSession?: () => void }).clearSession?.()
    sessionStorage.clear()
    localStorage.clear()
    await $auth0().logout({ logoutParams: { returnTo: `${location.origin}/` } })
  }
}
